export type ModuleId = 'livestock'
  | 'chief'
  | 'wiki';

export interface ModuleConfig {
  id: ModuleId;
  label: string;
  accent: string;
  icon: string;
  description: string;
}

export const MODULE_CONFIGS: Record<ModuleId, ModuleConfig> = {
  'livestock': {
    id: 'livestock',
    label: 'Livestock',
    accent: '#1B5E20',
    icon: 'Box',
    description: 'Livestock entities',
  },
  chief: {
    id: 'chief',
    label: 'Orchestrator',
    accent: '#F59E0B',
    icon: 'Bot',
    description: 'AI orchestrator — agents, workflows, chat',
  },
  wiki: {
    id: 'wiki',
    label: 'Knowledge Wiki',
    accent: '#8B5CF6',
    icon: 'BookMarked',
    description: 'LLM-maintained knowledge base — ingest, query, lint',
  },
};

export const MODULE_LIST: ModuleConfig[] = Object.values(MODULE_CONFIGS);
